module.exports = __webpack_public_path__ + "static/media/19ESCAP18.e1af7238.jpg";